import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthUser } from 'src/app/core/models/auth.models';
import { AuthStoreService } from 'src/app/core/store/services/auth-store.service';

@Component({
  selector: 'craft-porlal-account-menu',
  templateUrl: './porlal-account-menu.component.html',
  styleUrls: ['./porlal-account-menu.component.scss'],
  standalone: false,
})
export class PorlalAccountMenuComponent implements OnInit, OnDestroy {
  public user: AuthUser | undefined;
  private destroy$ = new Subject<void>();

  constructor(private authStore: AuthStoreService) {}

  public ngOnInit() {
    this.authStore.currentUser$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      this.user = user;
    });
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public logout() {
    this.authStore.logout().subscribe();
  }
}
